
// src/context/actionTypes.js

export const INIT = 'INIT';
export const RELOAD_DATA = 'RELOAD_DATA';
export const SET_DATA = 'SET_DATA';
export const SET_SETTINGS = 'SET_SETTINGS';
export const SELECT_NODE = 'SELECT_NODE';
export const SELECT_ROOT = 'SELECT_ROOT';
export const OPEN_EDIT_DIALOG = 'OPEN_EDIT_DIALOG';
export const SAVE_NODE_CHANGES = 'SAVE_NODE_CHANGES';
export const OPEN_PROPOSE_DIALOG = 'OPEN_PROPOSE_DIALOG';
export const OPEN_PROPOSAL_DIALOG = 'OPEN_PROPOSAL_DIALOG';
export const OPEN_EDIT_POSTS_DIALOG = 'OPEN_EDIT_POSTS_DIALOG';
export const BUTTON_POST_ADDED = 'BUTTON_POSTS_ADDED';
export const BUTTON_POST_UPDATED = 'BUTTON_POST_UPDATED';
export const BUTTON_POST_DELETED = 'BUTTON_POSTS_DELETED';
export const BUTTON_POSTS_UPDATED = 'BUTTON_POSTS_UPDATED';
export const VIEW_PROPOSAL = 'VIEW_PROPOSAL';
export const RESET_CHANGES = 'RESET_CHANGES';
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const DELETE_NODE_CLOSE_DIALOG = 'DELETE_NODE_CLOSE_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const OPEN_COMMIT_DIALOG = 'OPEN_COMMIT_DIALOG';
export const START_COMMIT_CHANGES = 'START_COMMIT_CHANGES';
export const COMMIT_CHANGES_SUCCESS = 'COMMIT_CHANGES_SUCCESS';
export const COMMIT_CHANGES_FAILED = 'COMMIT_CHANGES_FAILED';
export const RESET_COMMIT_CHANGES = 'RESET_COMMIT_CHANGES';
export const REJECT_PROPOSAL = 'REJECT_PROPOSAL';
export const SUBMIT_PROPOSAL = 'SUBMIT_PROPOSAL';
export const PROPOSAL_SUBMITTED_SUCCESS = 'PROPOSAL_SUBMITTED_SUCCESS';
export const PROPOSAL_SUBMITTED_FAILED = 'PROPOSAL_SUBMITTED_FAILED';

export const SHOW_MEDIA = 'SHOW_MEDIA';
export const LOAD_ERROR = 'LOAD_ERROR';
export const TOGGLE_EDIT_MODE = 'TOGGLE_EDIT_MODE';
export const MOVE_NODE = 'MOVE_NODE';
export const REORDER_NODE = 'REORDER_NODE';
export const ADD_CHILD_NODE = 'ADD_CHILD_NODE';
export const UNDO = 'UNDO';
export const REDO = 'REDO';
